import actionTypes from 'store/actionTypes';
import { initialUserInfoStateData } from 'store/initialStateData';

interface PropertyValue {
  data: any;
  loading: boolean;
}

interface Payload {
  [key: string]: PropertyValue;
}

export const userInfoReducer = (
  state: any = initialUserInfoStateData,
  action: { type: string; payload: Payload },
) => {
  const { payload } = action;
  switch (action.type) {
    case actionTypes.SET_USER_INFO: {
      const updatedContent = { ...state.content };

      // Handle multiple properties in payload
      Object.entries(payload).forEach(([property, value]) => {
        updatedContent[property] = {
          data: value?.data,
          loading: value?.loading,
        };
      });

      // Check if all properties have loading false
      const allLoadingFalse = Object.values(
        updatedContent as Record<string, PropertyValue>,
      )?.every((property) => property.loading === false);

      return {
        ...state,
        content: updatedContent,
        loading: allLoadingFalse ? false : state?.loading,
      };
    }

    default:
      return state;
  }
};
